/**
 * 消息提示工具
 * 简单的消息提示实现，可以根据需要替换为更复杂的UI库
 */

let messageContainer = null;

// 创建消息容器
const createMessageContainer = () => {
  if (!messageContainer) {
    messageContainer = document.createElement('div');
    messageContainer.id = 'message-container';
    messageContainer.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 9999;
      pointer-events: none;
    `;
    document.body.appendChild(messageContainer);
  }
  return messageContainer;
};

// 创建消息元素
const createMessageElement = (message, type = 'info') => {
  const messageEl = document.createElement('div');
  messageEl.style.cssText = `
    padding: 12px 20px;
    margin-bottom: 10px;
    border-radius: 8px;
    color: white;
    font-size: 14px;
    font-weight: 500;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateX(100%);
    transition: all 0.3s ease;
    pointer-events: auto;
    max-width: 300px;
    word-wrap: break-word;
  `;

  // 根据类型设置不同的背景色
  const colors = {
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6'
  };

  messageEl.style.backgroundColor = colors[type] || colors.info;
  messageEl.textContent = message;

  return messageEl;
};

/**
 * 显示消息提示
 * @param {string} message - 消息内容
 * @param {string} type - 消息类型：success, error, warning, info
 * @param {number} duration - 显示时长（毫秒），默认3000ms
 */
export const showMessage = (message, type = 'info', duration = 3000) => {
  const container = createMessageContainer();
  const messageEl = createMessageElement(message, type);
  
  container.appendChild(messageEl);

  // 触发动画
  setTimeout(() => {
    messageEl.style.transform = 'translateX(0)';
  }, 10);

  // 自动移除消息
  setTimeout(() => {
    messageEl.style.transform = 'translateX(100%)';
    messageEl.style.opacity = '0';
    
    setTimeout(() => {
      if (container.contains(messageEl)) {
        container.removeChild(messageEl);
      }
    }, 300);
  }, duration);

  // 点击关闭
  messageEl.addEventListener('click', () => {
    messageEl.style.transform = 'translateX(100%)';
    messageEl.style.opacity = '0';
    
    setTimeout(() => {
      if (container.contains(messageEl)) {
        container.removeChild(messageEl);
      }
    }, 300);
  });
};

// 便捷方法
export const showSuccess = (message, duration) => showMessage(message, 'success', duration);
export const showError = (message, duration) => showMessage(message, 'error', duration);
export const showWarning = (message, duration) => showMessage(message, 'warning', duration);
export const showInfo = (message, duration) => showMessage(message, 'info', duration);